import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* eslint-disable max-lines */
import * as React from 'react';
import { DropdownPopover, Outside } from '@cian/ui-kit';
import { Escape } from '@cian/ui-kit/services/Escape';
var isEmpty = require('lodash.isempty');
import { mergeStyles } from '@cian/utils';
import { ESuggestType, EInputType } from '../../types';
import { isBuildingSuggest } from '../../utils/types';
import { SuggestionInput } from '../SuggestionInput';
import { CloseButton } from '../CloseButton';
import { Preloader } from '../Preloader';
import { getSuggestionsCount, sortSuggestions } from '../../utils/suggestions';
import { SuggestionPopup } from '../SuggestionPopup';
import { Chevron } from '../Chevron';
import * as style from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SYMB_COUNT_FOR_POPUP = 2;
export var GeoSuggest = /*#__PURE__*/function (_React$Component) {
  _inherits(GeoSuggest, _React$Component);
  var _super = _createSuper(GeoSuggest);
  function GeoSuggest() {
    var _this;
    _classCallCheck(this, GeoSuggest);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "globalSuggestionsCount", 0);
    _defineProperty(_assertThisInitialized(_this), "rootRef", /*#__PURE__*/React.createRef());
    _defineProperty(_assertThisInitialized(_this), "inputRef", /*#__PURE__*/React.createRef());
    _defineProperty(_assertThisInitialized(_this), "state", {
      selectedItem: 0,
      isPopupOpen: false,
      hasFocus: false,
      flip: true
    });
    _defineProperty(_assertThisInitialized(_this), "onItemSelect", function (index) {
      _this.setState({
        selectedItem: index
      });
      if (_this.props.onItemSelect) {
        _this.props.onItemSelect(index);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
      var selectedItem = _this.state.selectedItem;
      if (!_this.props.suggestData || isEmpty(_this.props.suggestData.suggestions)) {
        return;
      }
      switch (event.keyCode) {
        //down
        case 40:
          event.preventDefault();
          _this.selectItem(selectedItem + 1);
          break;
        //up
        case 38:
          event.preventDefault();
          _this.selectItem(selectedItem - 1);
          break;

        //tab, enter
        case 9:
        case 13:
          event.preventDefault();
          _this.onEnterPress();
          break;
        default:
          break;
      }
    });
    _defineProperty(_assertThisInitialized(_this), "setSelectedValue", function () {
      var _this$props = _this.props,
        onValueChange = _this$props.onValueChange,
        _this$props$selectedV = _this$props.selectedValue,
        selectedValue = _this$props$selectedV === void 0 ? '' : _this$props$selectedV;
      onValueChange(selectedValue);
    });
    _defineProperty(_assertThisInitialized(_this), "onEnterPress", function () {
      if (!_this.props.suggestData || isEmpty(_this.props.suggestData.suggestions)) {
        return;
      }
      var index = _this.state.selectedItem || 0;
      var suggestions = sortSuggestions(_this.props.suggestData).reduce(function (acc, group) {
        return group !== undefined ? [].concat(_toConsumableArray(acc), _toConsumableArray(group)) : acc;
      }, []);
      var selected = suggestions[index];
      var cb = function cb() {
        return _this.props.onItemClick({
          title: selected.type === ESuggestType.geo ? selected.value : selected.fullName,
          group: selected.type,
          id: selected.type === ESuggestType.geo ? undefined : selected.id,
          regionId: selected.type === ESuggestType.geo ? undefined : selected.regionId,
          link: isBuildingSuggest(selected) ? selected.link : undefined
        });
      };
      _this.onBlur(cb);
    });
    _defineProperty(_assertThisInitialized(_this), "onChevronClick", function () {
      if (_this.state.isPopupOpen) {
        _this.onBlur(_this.setSelectedValue);
      } else {
        var input = _this.inputRef.current;
        if (input) {
          input.focus();
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onCloseButton", function () {
      _this.onBlur(function () {
        return _this.props.onValueChange('');
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onItemClick", function (params) {
      _this.onBlur(function () {
        return _this.props.onItemClick(params);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onFocus", function () {
      var error = _this.props.error;
      var input = _this.inputRef.current;
      if (input) {
        input.focus();
      }
      _this.setState({
        isPopupOpen: _this.props.value.length > SYMB_COUNT_FOR_POPUP && (_this.hasSuggestions(_this.props.suggestData) || !isEmpty(error)),
        hasFocus: true
      }, _this.props.onFocus);
    });
    _defineProperty(_assertThisInitialized(_this), "onBlur", function (callback) {
      var onBlur = _this.props.onBlur;
      var input = _this.inputRef.current;
      if (input) {
        input.blur();
      }
      _this.setState({
        isPopupOpen: false,
        selectedItem: 0,
        hasFocus: false
      }, callback);
      if (onBlur) {
        onBlur();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getPreloaderStyle", function () {
      var inputType = _this.props.inputType;
      switch (inputType) {
        case EInputType.mobile:
          return style['preloader-mobile'];
        case EInputType.mainpage:
          return style['preloader-mainpage'];
        case EInputType.search:
          return style['preloader-search'];
      }
      return undefined;
    });
    _defineProperty(_assertThisInitialized(_this), "hasSuggestions", function (suggestData) {
      return Boolean(suggestData && !isEmpty(suggestData.suggestions));
    });
    _defineProperty(_assertThisInitialized(_this), "handleSelectAndClose", function () {
      if (_this.state.isPopupOpen) {
        _this.onBlur(_this.setSelectedValue);
      }
    });
    return _this;
  }
  _createClass(GeoSuggest, [{
    key: "selectItem",
    value: function selectItem(index) {
      var selectedItem = index;
      if (index < 0) {
        selectedItem = this.globalSuggestionsCount - 1;
      } else if (index > this.globalSuggestionsCount - 1) {
        selectedItem = 0;
      }
      this.setState({
        selectedItem: selectedItem
      });
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(newProps) {
      var _this$props2 = this.props,
        error = _this$props2.error,
        value = _this$props2.value,
        suggestData = _this$props2.suggestData;
      if (newProps.value !== value || newProps.suggestData !== suggestData || error !== newProps.error) {
        this.setState({
          isPopupOpen: newProps.value.length > SYMB_COUNT_FOR_POPUP && this.state.hasFocus && (this.hasSuggestions(newProps.suggestData) || !isEmpty(newProps.error))
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        value = _this$props3.value,
        isLoading = _this$props3.isLoading,
        error = _this$props3.error,
        _this$props3$suggestD = _this$props3.suggestData,
        suggestData = _this$props3$suggestD === void 0 ? {
          sortOrder: [],
          suggestions: {}
        } : _this$props3$suggestD,
        disabled = _this$props3.disabled,
        placeholder = _this$props3.placeholder,
        onLinkClick = _this$props3.onLinkClick,
        inputStyle = _this$props3.inputStyle,
        inputType = _this$props3.inputType,
        popupStyle = _this$props3.popupStyle,
        onValueChange = _this$props3.onValueChange,
        renderInput = _this$props3.renderInput,
        itemsTruncation = _this$props3.itemsTruncation;
      var _this$state = this.state,
        isPopupOpen = _this$state.isPopupOpen,
        selectedItem = _this$state.selectedItem;
      this.globalSuggestionsCount = suggestData && getSuggestionsCount(suggestData.suggestions) || 0;
      return /*#__PURE__*/_jsx(DropdownPopover, {
        open: isPopupOpen,
        flip: this.props.flip,
        sameWidth: "width",
        content: /*#__PURE__*/_jsx(Escape, {
          onEscape: this.handleSelectAndClose,
          children: /*#__PURE__*/_jsx(Outside, {
            insideRefs: [this.rootRef],
            onOutside: this.handleSelectAndClose,
            children: /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx(SuggestionPopup, {
                suggestions: suggestData,
                selectedItem: selectedItem,
                inputType: inputType,
                error: error,
                containerStyles: popupStyle,
                onItemClick: this.onItemClick,
                onItemSelect: this.onItemSelect,
                onLinkClick: onLinkClick,
                itemsTruncation: itemsTruncation
              })
            })
          })
        }),
        children: /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
          ref: this.rootRef
        }, mergeStyles(style['geo-suggest'], disabled && style['disabled'])), {}, {
          children: [inputType === EInputType.mobile && value && !isLoading && /*#__PURE__*/_jsx(CloseButton, {
            onClick: this.onCloseButton
          }), isLoading && /*#__PURE__*/_jsx(Preloader, {
            customStyle: this.getPreloaderStyle()
          }), /*#__PURE__*/_jsxs("div", {
            className: style['input-wrapper'],
            children: [/*#__PURE__*/_jsx(SuggestionInput, {
              value: value,
              forwardRef: this.inputRef,
              inputStyle: inputStyle,
              inputType: inputType,
              disabled: disabled,
              placeholder: placeholder,
              onChange: onValueChange,
              onKeyDown: this.onKeyDown,
              onFocus: this.onFocus,
              renderInput: renderInput
            }), inputStyle === EInputType.mainpage && !isLoading && /*#__PURE__*/_jsx(Chevron, {
              isOpen: isPopupOpen,
              onClick: this.onChevronClick
            })]
          })]
        }))
      });
    }
  }]);
  return GeoSuggest;
}(React.Component);